<template>
  <div>
    <a-modal :visible="visible" :width="960" :confirmLoading="loading" :maskClosable="false" @cancel="cancel"
      @ok="confirm" wrapClassName="trace-template-modal">
      <div slot="title">{{ form.id ? '编辑展示模板' : '新增展示模板' }}</div>
      <a-row :gutter="16">
        <!-- 左侧编辑区 -->
        <a-col :span="15">
          <a-form-model ref="form" :model="localForm" :rules="rules" layout="vertical">
            <a-form-model-item prop="name" label="模板名称">
              <a-input v-model="localForm.name" placeholder="便于自己识别, 如: 小麦种子模板" />
            </a-form-model-item>
          </a-form-model>

          <a-tabs default-active-key="header" size="small">
            <!-- 头部 / 轮播 / 配色 -->
            <a-tab-pane key="header" tab="头部/轮播">
              <div class="field-label">配色</div>
              <div class="preset-row">
                <div v-for="p in presets" :key="p.key" class="preset-chip" :style="{ background: p.color }"
                  :title="p.name" @click="applyPreset(p)"></div>
                <span class="color-wrap">顶部
                  <input type="color" v-model="config.header_bg" class="color-input" /></span>
                <span class="color-wrap">按钮
                  <input type="color" v-model="config.nav_bg" class="color-input" /></span>
              </div>

              <a-row :gutter="8" class="mt">
                <a-col :span="24">
                  <div class="field-label">公司名称 (顶部大字)</div>
                  <a-input v-model="config.company_name" placeholder="如: 山东圣丰种业科技有限公司" size="small" />
                </a-col>
                <a-col :span="12" class="mt">
                  <div class="field-label">欢迎语</div>
                  <a-input v-model="config.welcome_text" placeholder="欢迎使用" size="small" />
                </a-col>
                <a-col :span="12" class="mt">
                  <div class="field-label">平台名 (顶部小字)</div>
                  <a-input v-model="config.platform_text" placeholder="种业防伪追溯平台" size="small" />
                </a-col>
              </a-row>

              <div class="field-label mt">Logo</div>
              <div class="list-row">
                <a-input v-model="config.logo" placeholder="图片地址, 或点右侧上传" size="small" allowClear />
                <a-upload :show-upload-list="false" :custom-request="(o) => customUpload(o, 'logo')" accept="image/*">
                  <a-button icon="upload" size="small">上传</a-button>
                </a-upload>
              </div>
              <img v-if="config.logo" :src="config.logo" class="thumb" />

              <div class="field-label mt">轮播图 (可多张)</div>
              <div v-for="(img, i) in config.gallery" :key="'g' + i" class="list-row">
                <a-input v-model="config.gallery[i]" placeholder="图片地址" size="small" />
                <a-button icon="delete" size="small" type="danger" @click="config.gallery.splice(i, 1)" />
              </div>
              <div class="btns-row">
                <a-upload :show-upload-list="false" :custom-request="(o) => customUpload(o, 'gallery')" accept="image/*">
                  <a-button icon="upload" size="small" type="primary">上传轮播图</a-button>
                </a-upload>
              </div>

              <div class="field-label mt">追溯网址 (首页展示, 可选)</div>
              <a-input v-model="config.trace_url" placeholder="如: https://yjny.yitihuo.cn" size="small" allowClear />

              <div class="field-label mt">首页-防伪验证文案 (自动带访问码与查询次数)</div>
              <a-textarea v-model="config.verify_text" :rows="2"
                placeholder="真诚感谢您的大力支持与信任，您所查询的为正宗产品！" />
            </a-tab-pane>

            <!-- 追溯信息 (子页一, 直接写 HTML) -->
            <a-tab-pane key="detail" tab="追溯信息">
              <a-alert type="info" show-icon style="margin-bottom: 8px;"
                message="直接写 HTML。可用小标题 <div class='tt'>标题</div> 和一行 <div class='dl'><span>名称</span><b>内容</b></div>。" />
              <div class="token-tip">
                可用变量(自动替换)：<b @click="insert('detail_html', '{code}')">{code}</b>
                <b @click="insert('detail_html', '{product_name}')">{product_name}</b>
                <b @click="insert('detail_html', '{scan_count}')">{scan_count}</b>
                <b @click="insert('detail_html', '{first_scan_time}')">{first_scan_time}</b>
                <b @click="insert('detail_html', '{last_scan_time}')">{last_scan_time}</b>
                <b @click="insert('detail_html', '{company_name}')">{company_name}</b>
              </div>
              <a-textarea v-model="config.detail_html" :rows="12" placeholder="在此编写追溯信息页 HTML" />
              <a-button size="small" style="margin-top: 6px;" @click="config.detail_html = defaultDetail">
                恢复默认模板
              </a-button>
            </a-tab-pane>

            <!-- 公司简介 (子页二) -->
            <a-tab-pane key="about" tab="公司简介">
              <a-alert type="info" show-icon style="margin-bottom: 10px;"
                message="直接写 HTML。插图: 先在「头部/轮播」上传拿到地址, 再用 <img src='地址'> 插入。" />
              <a-textarea v-model="config.about_html" :rows="12"
                placeholder="<p>公司介绍……</p>&#10;<p><img src='上传得到的地址'></p>" />
            </a-tab-pane>

            <!-- 田间照片 (子页三) -->
            <a-tab-pane key="atlas" tab="田间照片">
              <a-alert type="info" show-icon style="margin-bottom: 10px;"
                message="直接写 HTML。放照片: 先在「头部/轮播」上传拿到地址, 再用 <img src='地址'> 插入。" />
              <a-textarea v-model="config.atlas_html" :rows="12"
                placeholder="<p><img src='上传得到的地址'></p>&#10;<p><img src='上传得到的地址'></p>" />
            </a-tab-pane>

            <!-- 企业 / 底部 -->
            <a-tab-pane key="enterprise" tab="企业/底部">
              <div class="field-label">企业名称</div>
              <a-input v-model="config.enterprise.name" size="small" />
              <a-row :gutter="8" class="mt">
                <a-col :span="12">
                  <div class="field-label">生产经营者 (留空则用企业名称)</div>
                  <a-input v-model="config.producer" size="small" allowClear />
                </a-col>
                <a-col :span="12">
                  <div class="field-label">企业微信文案</div>
                  <a-input v-model="config.wechat_text" size="small" allowClear />
                </a-col>
                <a-col :span="12" class="mt">
                  <div class="field-label">联系电话</div>
                  <a-input v-model="config.enterprise.phone" size="small" />
                </a-col>
                <a-col :span="12" class="mt">
                  <div class="field-label">官网</div>
                  <a-input v-model="config.enterprise.website" size="small" />
                </a-col>
              </a-row>
              <div class="field-label mt">企业地址</div>
              <a-input v-model="config.enterprise.address" size="small" />

              <a-row :gutter="8" class="mt">
                <a-col :span="12">
                  <div class="field-label">联系二维码</div>
                  <div class="list-row">
                    <a-input v-model="config.qrcode_image" placeholder="图片地址" size="small" allowClear />
                    <a-upload :show-upload-list="false" :custom-request="(o) => customUpload(o, 'qrcode')" accept="image/*">
                      <a-button icon="upload" size="small">上传</a-button>
                    </a-upload>
                  </div>
                  <img v-if="config.qrcode_image" :src="config.qrcode_image" class="thumb" />
                </a-col>
                <a-col :span="12">
                  <div class="field-label">底部文案</div>
                  <a-input v-model="config.footer_text" size="small" allowClear />
                </a-col>
              </a-row>

              <a-row :gutter="8" class="mt">
                <a-col :span="12">
                  <a-checkbox v-model="localForm.is_default">设为默认模板</a-checkbox>
                </a-col>
                <a-col :span="12">
                  <div class="field-label">备注</div>
                  <a-input v-model="localForm.remark" size="small" allowClear />
                </a-col>
              </a-row>
            </a-tab-pane>
          </a-tabs>
        </a-col>

        <!-- 右侧预览 (与消费者扫码看到的完全一致, 可点击切换子页) -->
        <a-col :span="9">
          <div class="preview-title">
            落地页预览
            <span class="preview-tip">点下方按钮切换三个子页</span>
          </div>
          <div class="phone">
            <trace-view :info="previewInfo" :preview="true" />
          </div>
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
  import { traceTemplateCreate, traceTemplateUpdate, traceImageUpload } from '@/api/trace'
  import TraceView from '@/views/trace/public/TraceView.vue'
  import { DEFAULT_DETAIL_HTML } from '@/views/trace/constants'

  const defaultConfig = () => ({
    theme_color: '#009b4c',
    header_bg: '#009b4c',
    nav_bg: '#159442',
    company_name: '',
    welcome_text: '欢迎使用',
    platform_text: '种业防伪追溯平台',
    logo: '',
    gallery: [],
    trace_url: '',
    verify_text: '真诚感谢您的大力支持与信任，您所查询的为正宗产品！',
    detail_html: DEFAULT_DETAIL_HTML,
    about_html: '',
    atlas_html: '',
    enterprise: { name: '', phone: '', address: '', website: '' },
    producer: '',
    wechat_text: '联系当地指定经销商',
    qrcode_image: '',
    footer_text: '技术支持',
  });

  const PRESETS = [
    { key: 'green', name: '溯源绿', color: '#009b4c', config: { theme_color: '#009b4c', header_bg: '#009b4c', nav_bg: '#159442' } },
    { key: 'blue', name: '经典蓝', color: '#1890ff', config: { theme_color: '#1890ff', header_bg: '#1890ff', nav_bg: '#096dd9' } },
    { key: 'red', name: '防伪红', color: '#f5222d', config: { theme_color: '#f5222d', header_bg: '#cf1322', nav_bg: '#a8071a' } },
    { key: 'gold', name: '高端金', color: '#b8860b', config: { theme_color: '#b8860b', header_bg: '#8a6d09', nav_bg: '#6b5307' } },
  ];

  export default {
    name: 'FormModal',
    components: { TraceView },
    props: ['visible', 'form'],
    model: { prop: 'visible', event: 'cancel' },
    data() {
      return {
        loading: false,
        localForm: {},
        config: defaultConfig(),
        presets: PRESETS,
        defaultDetail: DEFAULT_DETAIL_HTML,
        rules: {
          name: [{ required: true, message: '请输入模板名称', trigger: 'blur' }],
        },
      };
    },
    computed: {
      // 用示例数据 + 当前配置驱动实时预览
      previewInfo() {
        return {
          code: '0320709101427099',
          product_name: '山农32号',
          batch_number: 'B20260722001',
          production_date: '2026-07-01',
          scan_count: 24,
          first_scan_time: '2026-07-08 18:16:59',
          last_scan_time: '2026-07-22 10:03:03',
          template: this.config,
        };
      },
    },
    watch: {
      visible(value) {
        if (value) {
          this.localForm = { ...this.form };
          // 合并默认值, 兼容旧数据缺失字段
          let saved = this.form.config || {};
          this.config = {
            ...defaultConfig(),
            ...saved,
            enterprise: { ...defaultConfig().enterprise, ...(saved.enterprise || {}) },
            gallery: saved.gallery || [],
          };
        }
      },
    },
    methods: {
      applyPreset(preset) {
        this.config = { ...this.config, ...preset.config };
      },
      insert(field, token) {
        this.config[field] = (this.config[field] || '') + token;
      },
      // 图片上传到后端服务器, 成功后写入对应配置字段
      customUpload({ file, onSuccess, onError }, target) {
        traceImageUpload(file).then(res => {
          if (target === 'logo') this.config.logo = res.url;
          else if (target === 'qrcode') this.config.qrcode_image = res.url;
          else if (target === 'gallery') this.config.gallery.push(res.url);
          onSuccess(res, file);
          this.$message.success('上传成功');
        }).catch(err => {
          onError(err);
          this.$message.error('图片上传失败');
        });
      },
      confirm() {
        this.$refs.form.validate(valid => {
          if (!valid) return;
          this.loading = true;
          let payload = { ...this.localForm, config: this.config };
          let func = payload.id ? traceTemplateUpdate : traceTemplateCreate;
          func(payload).then(data => {
            this.$message.success(payload.id ? '修改成功' : '新增成功');
            this.$emit(payload.id ? 'update' : 'create', data);
            this.cancel();
          }).finally(() => {
            this.loading = false;
          });
        });
      },
      cancel() {
        this.$emit('cancel', false);
        if (this.$refs.form) this.$refs.form.clearValidate();
      },
    },
  }
</script>

<style scoped>
  .field-label { color: #666; font-size: 13px; margin-bottom: 4px; }
  .mt { margin-top: 10px; }
  .list-row { display: flex; align-items: center; gap: 6px; margin-bottom: 6px; }
  .btns-row { display: flex; align-items: center; gap: 8px; margin-top: 6px; }
  .thumb { max-width: 90px; max-height: 90px; margin-top: 6px; border: 1px solid #eee; border-radius: 4px; display: block; }
  .token-tip { font-size: 12px; color: #999; margin-bottom: 6px; line-height: 1.8; }
  .token-tip b { color: #009b4c; background: #f6fff9; border: 1px solid #b7ebc9; border-radius: 3px; padding: 0 5px; margin-right: 5px; cursor: pointer; font-weight: 500; }

  .preset-row { display: flex; align-items: center; gap: 8px; }
  .preset-chip { width: 26px; height: 26px; border-radius: 50%; cursor: pointer; border: 2px solid #fff; box-shadow: 0 0 0 1px #ddd; }
  .color-wrap { font-size: 12px; color: #666; display: inline-flex; align-items: center; gap: 4px; }
  .color-input { width: 34px; height: 24px; border: 1px solid #ddd; padding: 0; vertical-align: middle; }

  .preview-title { color: #999; margin-bottom: 8px; }
  .preview-tip { margin-left: 8px; font-size: 12px; color: #bbb; }
  .phone {
    position: relative;
    height: 620px;
    overflow-y: auto;
    border: 1px solid #eee;
    border-radius: 12px;
    background: #fff;
  }
</style>
